"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const utils_1 = require("../../utils/utils");
require("../../styles/components/simple-user-avatar.less");
// !!!!! MUST PASS HERE THE USER MAP AS PROPD in tha past we call here as: const usersMap = useSelector((state) => get(state, 'users.usersMap', {}), shallowEqual);!!!
const SimpleUserAvatar = (0, react_1.memo)(({ email = '', fullName = '', showFullName = false, size, usersMap }) => {
    // const usersMap = useSelector((state) => get(state, 'users.usersMap', {}), shallowEqual);
    const fullUser = (0, react_1.useMemo)(() => (email ? usersMap[email.toLowerCase()] || {} : {}), [usersMap, email]);
    const src = (0, react_1.useMemo)(() => (fullUser.avatarId ? (0, utils_1.uploadcareUrl)(fullUser.avatarId, size) : `${(0, utils_1.gravatarUrl)(email, size)}`), [fullUser.avatarId, size, email]);
    const name = fullName || fullUser.fullName || email;
    return (react_1.default.createElement("div", { className: "simple-gravatar-container" },
        react_1.default.createElement("div", { className: (0, classnames_1.default)('simple-gravatar-img-wrapper', { 'custom-avatar': fullUser.avatarId }) }, src && react_1.default.createElement("img", { src: src, alt: "", className: "simple-gravatar-image" })),
        !fullUser.avatarId && react_1.default.createElement("div", { className: "simple-gravatar-initials" }, (0, utils_1.getInitials)(name)),
        showFullName && name && react_1.default.createElement("span", { className: "simple-gravatar-fullname" }, name)));
});
exports.default = SimpleUserAvatar;
//# sourceMappingURL=simple-user-avatar.js.map